import StandRadioSelect from "./stands-radio-select";

export default StandRadioSelect;